import { Module } from 'vuex';
import PageInterface from '@/interfaces/PageInterface';
import { PageAPI } from '@/api';

const pageModule: Module<any, any> = {
  namespaced: true,

  state: {
    status: 0,
    fetched: true,
    page: null as PageInterface | null,
    type: 'common',
    error: null,
  },

  mutations: {
    SET_STATUS(state, status: number) {
      state.status = status;
    },
    SET_FETCHED(state, fetched: number) {
      state.fetched = fetched;
    },
    SET_PAGE(state, page: PageInterface) {
      state.page = page;
    },
    SET_PAGE_TYPE(state, pageType: string) {
      state.pageType = pageType;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
  },

  actions: {
    setInitialPageData({ commit, dispatch }, data: { page: PageInterface, preview: boolean }) {
      commit('SET_PAGE', data.page);
      dispatch('partner/switch', data.page.partner, {
        root: true,
      });
      commit('SET_STATUS', 0);
    },
    fetch({ commit, dispatch }, data: Record<string, any>) {
      commit('SET_STATUS', 1);
      PageAPI.get(data)
        .then((response: PageInterface | null) => {
          commit('SET_ERROR', null);
          commit('SET_PAGE', response);
          dispatch('partner/switch', response?.partner, {
            root: true,
          });
        }).catch((e) => {
          commit('SET_ERROR', e);
          commit('SET_PAGE', null);
          dispatch('partner/switch', null, {
            root: true,
          });
        }).finally(() => {
          commit('SET_STATUS', 0);
        });
    },
    setPageType({ commit }, pageType: string) {
      commit('SET_PAGE_TYPE', pageType);
    },
    setStatus({ commit }, status: number) {
      commit('SET_STATUS', status);
    },
    setFetched({ commit }, fetched: number) {
      commit('SET_FETCHED', fetched);
    },
  },

  getters: {
    status(state): number {
      return state.status;
    },
    fetched(state): number {
      return state.fetched;
    },
    page(state): PageInterface {
      return state.page;
    },
    pageType(state): string {
      return state.pageType;
    },
    isOrderPage(state): boolean {
      return state.pageType === 'order';
    },
    hasOrder(state): boolean {
      return !!state.page?.hasOrder;
    },
  },
};

export default pageModule;
